module.exports = __webpack_public_path__ + "avatar_default.png?181d7a19aa4627a3411c73d5c20d274d";